import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualBackofficePageRoutingModule } from './manual-backoffice-routing.module';

import { ManualBackofficePage } from './manual-backoffice.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualBackofficePageRoutingModule
  ],
  declarations: [ManualBackofficePage],
  exports: [
    ManualBackofficePage
  ],
})
export class ManualBackofficePageModule {}
